"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchContentsFromJSON = SearchContentsFromJSON;
exports.SearchContentsFromJSONTyped = SearchContentsFromJSONTyped;
exports.SearchContentsToJSON = SearchContentsToJSON;
exports.SearchContentsToJSONTyped = SearchContentsToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function SearchContentsFromJSON(json) {
    return SearchContentsFromJSONTyped(json, false);
}
function SearchContentsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'totalCount': !(0, runtime_1.exists)(json, 'totalCount') ? undefined : json['totalCount'],
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'].map(_1.ContentDataFromJSON)),
    };
}
function SearchContentsToJSON(value) {
    return SearchContentsToJSONTyped(value, false);
}
function SearchContentsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'totalCount': value.totalCount,
        'items': value.items === undefined ? undefined : (value.items.map(_1.ContentDataToJSON)),
    };
}
